import React from 'react';
import Loader from '../../../../components/loader';
import { ReportsUtils } from '../../../../utils/reportsUtils';
import Table from './table';
import { ReportField, ReportMetadataField, SrcFieldValue } from '../../../../constnats/reportConstants';
import Utils from '../../../../utils/descriptor/descriptorUtils';
import TableAndP2pConfig from '../../../../components/financialTables/configuration/tableAndP2pConfig';
import FilterAndSortCfg from '../../../../components/financialTables/configuration/filterAndSortConfig';
import { Form, Icon } from 'semantic-ui-react';
import { applyFilterCfg } from '../../../../components/financialTables/configuration/applyUtill';
import UserPreferences from '../../../../service/userPreferences';
import { getResourceFilter } from '../../../../utils/reportResourceUtil';
import { ConfigProps, PropValues, SETTINGS_PROFILE } from '../../../../components/financialTables/configuration/constants';
import ReportUtils from '../../../../utils/reportUtils';
import { CreateReportModal, UpdateReportModal } from "../clientReportsMnmgt"
import Alert from '../../../../utils/alert';
import GlobalReportsRepo from '../../../../utils/repository/globalRepoertsRepo';
import AuthService from '../../../../service/auth';
import TableActionButton from '../../../../components/buttons/tableActionButton';
import { DescriptorProps } from '../../../../constnats/descriptor';
import { BranchTypes } from '../../../../constnats/schemaConstants';
import { getCategorizedDescriptors } from '../../../../utils/categorization/descriptorsCategorization';
import { getCategorizedReports } from '../../../../utils/categorization/reportsCategorization';
import objectHash from 'object-hash';
import CollectionUtils from '../../../../utils/collections';
import { ROLES } from '../../../../constnats/user';
import FilterAndSortCfgV2 from '../../../../components/financialTables/configuration/filterAndSortConfigV2';
import TableAndP2pConfigV2 from '../../../../components/financialTables/configuration/tableAndP2pConfigV2';
import { SelectField } from '../../../../components/financialTables/configuration/fields';
import KeyValue from '../../../../structures/keyValePair';
import StandardizedLabelsRepo from '../../../../utils/repository/standardizedLabelsRepo/standardizedLabelsRepo';
import { RESPONSE_STATUS } from '../../../../constnats/general';

/**
 * Note: Difference between tableWrapper merge function (client view) and reports merge function(filler view)
 * In the client view there are additional types of reports(MANAGED Reports)
 * which should be accounted for, whereas these types of reports are not present in the filler view.
 * Because of this difference there is a significant difference between the logic of the two
 */
/**
 * Function for report merge during horizontal calculations
 * @param {*} a Required 
 * @param {*} b Required
 */
function reportsMergeFunction(a, b) {
    if (a[ReportField.MANAGED] === false && b[ReportField.MANAGED] === true) {
        //b is managed report and a is client report
        ReportUtils.setMetadataProp(a, ReportMetadataField.OBSOLETE, true)

        return b
    } else if (a[ReportField.MANAGED] === true && b[ReportField.MANAGED] === false) {
        //a is managed report and b is client report
        ReportUtils.setMetadataProp(b, ReportMetadataField.OBSOLETE, true)
        return a
    } else {
        ReportUtils.setMetadataProp(a, ReportMetadataField.DUPLICATE, true)
        ReportUtils.setMetadataProp(b, ReportMetadataField.DUPLICATE, true)

        Alert.warn("There are more than one reports for "
            + a.year + ", " + a.period + ", " + a.type + ", " +
            a.reportType + ". This can lead to a incorrect calculations in the calculated periods."
            + " The duplicated periods are marked with red. Please delete the duplicates.")
        return b
    }
}

function AddReportButton({ branchType, isAuthenticated, openCreateReportModal }) {
    return (
        <>
            {
                branchType === "MAIN" && isAuthenticated &&
                <TableActionButton onClick={openCreateReportModal}>
                    Add Report
                </TableActionButton>
            }
        </>
    )
}

function CurrencyInfo({ currency }) {
    return <span>Currency: <b>{currency}</b></span>
}

class DescriptorsKnowledge {

    constructor(descriptors, categoryBasedMode) {
        this._toRender = categoryBasedMode ? getCategorizedDescriptors(descriptors) : descriptors
        this._flatDynamicToRender = Utils.flatDescriptors(this._toRender, true)
        this._flatToRender = Utils.flatDescriptors(this._toRender)
        this._flatDynamic = Utils.flatDescriptors(descriptors, true)
        this._nonCategorizedFlatDynamicDescriptorsMap = CollectionUtils.arrToMap(this._flatDynamic, (d) => d.id)
    }

    getDescriptorsToRender() {
        return this._toRender
    }

    getFlatDescriptorsToRender() {
        return this._flatToRender
    }

    getFlatDynamicDescriptorsToRender() {
        return this._flatDynamicToRender
    }

    getFlatDynamicDescriptors() {
        return this._flatDynamic
    }

    getNonCategorizedFlatDynamicDescriptorsMap() {
        return this._nonCategorizedFlatDynamicDescriptorsMap
    }
}

class ReportsTable extends React.Component {

    constructor(props) {
        super(props)
        const categoryBasedMode = UserPreferences.get(UserPreferences.TABLE_CFG_PROP)[ConfigProps.CATEGORY_BASED_MODE]

        this.descriptorsKnowledge = new DescriptorsKnowledge(this.props.schema.descriptors, categoryBasedMode)
        this.reportsUtil = new ReportsUtils(this.descriptorsKnowledge.getFlatDynamicDescriptors())
        this.chartsRef = React.createRef();

        this.state = {
            reports: null,
            modal: null,
            filterCfg: UserPreferences.get(UserPreferences.FILTER_CFG_PROP),
            tableConfig: UserPreferences.get(UserPreferences.TABLE_CFG_PROP),
            descriptorsHash: null,
            profile: UserPreferences.getPreferredProfile(),
            standardizedLabels: [],
            /**
             * Provenance is a large payload only Source view needs, so reports load without it and
             * are re-fetched with it the first time a user opens Source view. Sticky from then on,
             * so every later reload keeps it and toggling Source view off and on again is free.
             */
            provenanceRequested: false,
            provenanceLoading: false,
        }
    }

    componentDidMount() {
        this.reloadReports()
        StandardizedLabelsRepo.listStandardizedLabels((response) => {
            if(response.status === RESPONSE_STATUS.SUCCESS) {
                this.setState({standardizedLabels: response.data})
            }
        })
    }

    componentDidUpdate(__, prevState) {
        /**
         * Check the category mode. If we are in category mode we change the descriptors to render
         * to the categorized descriptors and then we reload the reports which will later be categorized
         * if category mode is on.
         */
        const prevStateCategoryBasedMode = prevState.tableConfig[ConfigProps.CATEGORY_BASED_MODE];
        const currentStateCategoryBasedMode = this.state.tableConfig[ConfigProps.CATEGORY_BASED_MODE]
        if (prevStateCategoryBasedMode !== currentStateCategoryBasedMode) {
            this.descriptorsKnowledge = new DescriptorsKnowledge(this.props.schema.descriptors, currentStateCategoryBasedMode)
            this.reloadReports()
        }
    }

    reloadReports() {
        GlobalReportsRepo.listBySchema(this.props.schema.id, (reports) => this.setReports(reports),
            undefined, this.state.provenanceRequested)
    }

    /**
     * Re-fetches the reports with their provenance the first time Source view is opened. A no-op
     * afterwards: the flag is sticky, so the reports already carry it.
     */
    requestProvenance = () => {
        if (this.state.provenanceRequested) {
            return
        }
        this.setState({ provenanceRequested: true, provenanceLoading: true },
            () => this.reloadReports())
    }

    setReports(nonCalcedReports) {
        const enableAsserts = this.props.schema.branchType === BranchTypes.MAIN;
        const calculatedReports = this.reportsUtil.getCalculatedReports(nonCalcedReports,
            reportsMergeFunction, enableAsserts)

        nonCalcedReports.forEach(report => {
            const fs = ReportUtils.getFieldsMetadata(report)
            let metadataToAdd = {}
            if (report[ReportField.MANAGED] === true) {
                metadataToAdd = { resourceFilterProvider: () => getResourceFilter(report, this.props.companyId) }
            } else {
                metadataToAdd = { editFunc: () => this.openEditReportModal(report.id) }
            }

            fs[ReportField.PERIOD] = Object.assign(metadataToAdd, fs[[ReportField.PERIOD]])
        });

        const nonCategorizedReports = nonCalcedReports.concat(calculatedReports)

        const reportsToRender = this.state.tableConfig[ConfigProps.CATEGORY_BASED_MODE] ?
            getCategorizedReports(this.descriptorsKnowledge.getFlatDescriptorsToRender(), nonCategorizedReports, this.descriptorsKnowledge.getNonCategorizedFlatDynamicDescriptorsMap()) : nonCategorizedReports
        this.setState({
            reports: reportsToRender,
            provenanceLoading: false,
            descriptorsHash: objectHash(this.descriptorsKnowledge.getDescriptorsToRender())
        })
    }

    onSettingsChange(prop, cfg) {
        this.setState({ [prop]: cfg });
    }

    openEditReportModal(reportId) {
        this.openModal(<UpdateReportModal
            {...{ reportId }}
            schema={this.props.schema}
            onCancel={() => this.closeModal()}
            onUpdated={() => {
                this.reloadReports()
                this.closeModal()
            }} />)
    }

    openCreateReportModal = () => {
        const knownReports = this.state.reports.filter(r => r[ReportField.SRC] !== SrcFieldValue.CALCULATED)
        this.openModal(<CreateReportModal
            knownReports={knownReports}
            schema={this.props.schema}
            onCancel={() => this.closeModal()}
            onCreated={() => {
                this.reloadReports()
                this.closeModal()
            }} />)
    }

    openModal(modal) {
        this.setState({ modal })
    }

    closeModal() {
        this.setState({ modal: null })
    }

    toggleAdvancedSettings = () => {
        this.setState({ filterCfg: { ...this.state.filterCfg, [ConfigProps.SHOW_ADVANCED_SETTINGS]: !this.state.filterCfg[ConfigProps.SHOW_ADVANCED_SETTINGS] } })
        /**
         * Currently there are some issues with the styles which lead to the bottom scrollbar
         * disappearing when the advances settings are opened (this problem does not exist in filler view)
         * by scrolling one pixel it forces the scrollbar to reappear fixing the problem
         */
        window.scrollBy(0, 1)
    }

    onProfileChange = (profile) => {
        UserPreferences.updateProfile(profile);
        this.setState({ profile: profile, filterCfg: UserPreferences.get(UserPreferences.FILTER_CFG_PROP), tableConfig: UserPreferences.get(UserPreferences.TABLE_CFG_PROP) })
    }

    onProfileReset = () => {
        UserPreferences.resetProfile();
        this.setState({ filterCfg: UserPreferences.get(UserPreferences.FILTER_CFG_PROP), tableConfig: UserPreferences.get(UserPreferences.TABLE_CFG_PROP) })
    }

    getProfileSettingsComponent = () => {
        return (
            <>
                {AuthService.hasGlobalRole(ROLES.EMPLOYEE) &&
                    <div className='flex profile-settings-container tableConfigSegment '>
                        <div className='configModule'>
                            <SelectField
                                className='profile-select'
                                opsKV={Object.values(SETTINGS_PROFILE).map(pO => KeyValue.createSame(pO))}
                                val={this.state.profile}
                                onChange={(v) => this.onProfileChange(v)}
                            />
                        </div>
                        <TableActionButton onClick={this.onProfileReset} className='reset-profile-button'>
                            <Icon name="redo" />
                        </TableActionButton>
                    </div>
                }
            </>
        )
    }

    render() {
        const tableConfig = this.state.tableConfig
        const filterCfg = this.state.filterCfg
        const flatDynamicDescriptorsToRender = this.descriptorsKnowledge.getFlatDynamicDescriptorsToRender()
        return this.state.reports === null ? <Loader /> :
            <>
                <>{this.state.modal}</>
                <ConfigForm filterCfg={filterCfg}
                    tableConfig={tableConfig}
                    onChange={(prop, cfg) => this.onSettingsChange(prop, cfg)}
                    chartsRef={this.chartsRef} />
                {/* in order to reset the expand collapse manager state we need to recreate the table 
                with the new descriptors */}
                <Table key={this.state.descriptorsHash}
                    onSourceViewEnabled={this.requestProvenance}
                    provenanceLoading={this.state.provenanceLoading}
                    companyId={this.props.companyId}
                    standardizedLabels={this.state.standardizedLabels}
                    companyTitle={this.props.companyTitle}
                    companyName={this.props.companyName}
                    companyTicker={this.props.companyTicker}
                    schemaName={this.props.schema.name}
                    schemaId={this.props.schema.id}
                    reports={ReportsUtils.sort(applyFilterCfg(this.state.reports,
                        filterCfg,
                        tableConfig, flatDynamicDescriptorsToRender),
                        filterCfg[ConfigProps.REPORTS_ORDER] === PropValues.DESC)}
                    descriptors={this.descriptorsKnowledge.getDescriptorsToRender()}
                    dynamicFlatDescriptors={flatDynamicDescriptorsToRender}
                    {...tableConfig}
                    chartsRef={this.chartsRef}
                    prefferedScale={filterCfg[ConfigProps.PREFFERED_SCALE]}
                    currencyInfo={<CurrencyInfo currency={this.props.currency} />}
                    advancedSettingsBtn={null}
                    profileSettingsComponent={this.getProfileSettingsComponent()}
                    addReportBtn={<AddReportButton branchType={this.props.schema.branchType} isAuthenticated={AuthService.isAuthenticated()} openCreateReportModal={this.openCreateReportModal} />}
                    showPeriodGrowth={filterCfg[ConfigProps.SHOW_PERIOD_GROWTH_PERCENTAGES]}
                    showYearlyGrowth={filterCfg[ConfigProps.SHOW_YEARLY_GROWTH_PERCENTAGES]}
                    nonCategorizedFlatDynamicDescriptorsMap={this.descriptorsKnowledge.getNonCategorizedFlatDynamicDescriptorsMap()}
                    descending={filterCfg[ConfigProps.REPORTS_ORDER] === PropValues.DESC}
                />
            </>
    }
}

function ConfigForm({ filterCfg, tableConfig, onChange, chartsRef }) {

    const onChangeInternal = settings => {
        const prop = Object.keys(settings)[0]
        UserPreferences.save(prop, settings[prop])
        onChange(prop, settings[prop])
    }

    return <Form size="mini">
        <FilterAndSortCfgV2 config={filterCfg}
            advancedConfig={tableConfig}
            onAdvancedChange={tableConfig => onChangeInternal({ tableConfig })}
            onChange={filterCfg => onChangeInternal({ filterCfg })}
            granularPeriodsFiltering={tableConfig[ConfigProps.GRANULAR_PERIODS_FILTERING]} />
        {filterCfg[ConfigProps.SHOW_ADVANCED_SETTINGS] && <TableAndP2pConfigV2 chartsRef={chartsRef} tableConfig={tableConfig}
            onTableConfigChange={tableConfig => onChangeInternal({ tableConfig })}
        />}
    </Form>
}

export default ReportsTable